module.exports = __webpack_public_path__ + "static/media/prefill-gif-hippo-green.80b93e96.gif";